

import { types } from "../types"


export const getCustomerCallTypesAction = () => {

    return {
        type: types.GET_CUSTOMER_CALL_TYPES_REQUEST,
    }
}



export const getCustomerContactsAction = () => {

    return {
        type: types.GET_CONTACTS_REPORT_REQUEST,
    }
}


export const getCallReportToExport = (params) => {

    return {
        type: types.GET_CALL_REPORT_TO_EXPORT_REQUEST,
        params
    }
}



export const getCallReportFileAction = (params) => {

    return {
        type: types.GET_CALL_REPORT_FILE_REQUEST,
        params
    }
}


export const getCustomerCallsAction = (params) => {

    return {
        type: types.CALL_REPORT_REQUEST,
        params
    }
}

//call direcr*****************************************************************************************************************************//
export const getCustomerCallsDirectAction = (params) => {

    return {
        type: types.CALL_REPORT_CALL_DIRECT_REQUEST,
        params
    }
}
